import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { format } from 'date-fns';
import {CAMPAIGN_ALL_LINK} from '../../constants/constants'
import { notifyError, notifySuccess, notifyInfo } from '../../helper';
import Trophy from '../../assets/images/trophy.svg';
import client from '../../api';

const CampaignRow = (props) => {
    const {campaign} = props;
    const api = client();
    const [loading,setLoading] = useState(false);
    
    const changeCampaignStatus = async (type) => {
        const currentStatus = Object.keys(campaign).length ? campaign.status : '';
        if(currentStatus === type){
            notifyInfo(`This campaign is already in ${currentStatus} state`);
            return;
        }
        try{
            setLoading(true);
            const response = await api.post('/v1/campaign/status/update',{
                campaigns_id:[campaign._id],
                status: type,
            });

            if(response.status === 200 || response.status === 201){
                setLoading(false);                
                notifySuccess('Campaign Status updated successfully');
                setTimeout(()=>{
                    window.location.href = CAMPAIGN_ALL_LINK;
                },2000);
            }

        } catch(error){
            console.log('error.message',error);
            setLoading(false);
            if(error.status === 400) notifyError('Bad Request. Not able to change campaign status');
        }
    }

    const MessageIcons = ({count}) => {
        const mailIcons = Array.from({ length: count });
        if(!count){
            return(<span style={{visibility:'hidden'}}><i className="bx bx-mail-send"></i></span>);
        } else {
            return(<>
                {mailIcons.map((a,i)=>(<span key={i}><i className="bx bx-mail-send"></i></span>))}
            </>);
        }
        
    }

    return(<>
        <tr>
            <td>
                <label>
                    <input type="checkbox" id="select-01" checked={campaign.isChecked} onChange={()=>{props.handleCheckboxChange(campaign._id)}} />
                </label>
            </td>
            <td>
                {campaign.status === "started" ? <>
                    <button 
                        className="campaign-pause" 
                        onClick={()=>{
                            changeCampaignStatus('paused');
                        }}>
                        {loading ? <div className="loader"></div> : <i className='bx bx-pause'></i>}
                    </button>
                </>:''}

                {campaign.status === "paused" ? <>
                    <button 
                        className="campaign-play" 
                        onClick={()=>{
                            changeCampaignStatus('started');
                        }}>
                        {loading ? <div className="loader"></div> : <i className='bx bx-play'></i>}
                    </button>
                </>:''}

                {campaign.status === "complete" ? <div className="trophy-2"><Trophy/></div>:''}
                {campaign.status === "scheduled" ? <>
                    <div 
                        className="campaign-scheduled">
                            <i className='bx bx-time-five' style={{fontSize:'18px'}}></i>
                    </div>
                </>:''}
                {/*dummy button*/}   
                {(campaign.status === "Draft") ? <button className="campaign-pause" style={{visibility:'hidden'}}><i className='bx bx-pause'></i></button>:'' }
            </td>
            <td>
                <div className="campaign-name">
                    {campaign.status === 'Draft' ? 
                    <Link to={`/campaign/${campaign._id}/${campaign.current_tab}`} title={campaign.name}>{campaign.name}</Link>:<Link to={`/campaign/${campaign._id}/overview`} title={campaign.name}>{campaign.name}</Link> }                    
                </div>
                <div className="message-sequence">
                    <MessageIcons count={campaign.steps_count} />
                    {/* <span><i className="bx bx-mail-send"></i></span> */}
                </div>
            </td>
            <td title={format(campaign.created_at, 'MMM d, yyyy')}>
                {format(campaign.created_at, 'MMM d, yyyy')} 
            </td>
            <td title={campaign?.assigned_to_user?.status === 'deleted' ? 'Not Assigned' : campaign?.assigned_to_user?.email}>
                {campaign?.assigned_to_user?.status === 'deleted' ? <span style={{color:'#ff6ab1'}}>Not Assigned</span> : campaign?.assigned_to_user?.email}
            </td>
            <td>
                <div className="row-data">
                    <div className="col-data col-data-01">
                        <span className="field-value">{campaign.recipients_count}</span>
                        <span className="field-label">Recipients</span>
                    </div>
                    <div className="col-data col-data-02">
                        <span className="field-value">{campaign?.total_email_event_counts?.sent}</span>
                        <span className="field-label">Sent</span>
                    </div>
                    <div className="col-data col-data-03">
                        <span className="field-value">{campaign?.total_email_event_counts?.lead}</span>
                        <span className="field-label">Leads</span>
                    </div>
                    <div className="col-data col-data-04">
                        <span className="field-value">{campaign?.total_email_event_counts?.reply}</span>
                        <span className="field-label">Replies</span>
                    </div>
                    <div className="col-data col-data-05">
                        <span className="field-value">{campaign?.total_email_event_counts?.open}</span>
                        <span className="field-label">Opens</span>
                    </div>
                    <div className="col-data col-data-06">
                        <span className="field-value">{campaign?.total_email_event_counts?.bounce}</span>
                        <span className="field-label">Bounces</span>
                    </div>
                </div>
            </td>
        </tr>
    </>);
}

export default CampaignRow;